import { formatPercent } from '../OddsPanel/format';
import { tierBarFill } from './tierColors';

type Props = {
  name: string;
  /** Value range, pre-formatted by the backend (e.g. "$12 - $20"). */
  range: string;
  /** Drop chance, 0–100. */
  percentage: number;
};

/** Smallest fill (px) so a near-zero tier still reads as a sliver, not empty. */
const MIN_FILL_PX = 12;

/** "Common • $12 - $20 ……… 60%" over a bar in the tier's colour (partner Figma 2026-10-06). */
export function OddsSheetRow({ name, range, percentage }: Props) {
  const clamped = Math.max(0, Math.min(100, percentage));
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-3 text-[12px] leading-[16px] font-medium">
        <span className="min-w-0 truncate">
          <span className="text-[var(--co-OddsSheet-mutedText,#6D707C)]">{name} • </span>
          <span className="text-[var(--co-OddsSheet-text,#FFFFFF)]">{range}</span>
        </span>
        <span className="shrink-0 text-[var(--co-OddsSheet-text,#FFFFFF)]">
          {formatPercent(percentage)}%
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-[var(--co-OddsSheet-surface,#1A1B1F)]">
        <div
          className="h-full rounded-full"
          style={{ width: `max(${clamped}%, ${MIN_FILL_PX}px)`, background: tierBarFill(name) }}
        />
      </div>
    </div>
  );
}
